var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "current",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.1378 3.60628C10.9306 2.13124 13.0694 2.13124 13.8622 3.60628L15.9245 7.44315L20.2546 8.19559C21.9192 8.48485 22.5801 10.495 21.4055 11.6959L18.35 14.8196L18.9638 19.1215C19.1998 20.7753 17.4695 22.0176 15.9507 21.2848L12 19.3785L8.04933 21.2848C6.53054 22.0176 4.80016 20.7753 5.03616 19.1215L5.65004 14.8196L2.59451 11.6959C1.41985 10.495 2.0808 8.48485 3.74544 8.19559L8.07551 7.44315L10.1378 3.60628ZM12 4.58364L9.93775 8.42051C9.63297 8.98757 9.08065 9.3841 8.44071 9.4953L4.11064 10.2477L7.16617 13.3715C7.61774 13.8332 7.82871 14.4748 7.73799 15.1105L7.12411 19.4124L11.0748 17.5062C11.6586 17.2244 12.3414 17.2244 12.9252 17.5062L16.8759 19.4124L16.262 15.1105C16.1713 14.4748 16.3823 13.8332 16.8338 13.3715L19.8894 10.2477L15.5593 9.4953C14.9194 9.3841 14.367 8.98757 14.0622 8.42051L12 4.58364Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.b5648b4f373ef3084e8566fe01345645.svg";
export { ForwardRef as ReactComponent };